import { useRequiredContext } from "@lib/utils";

import { FloorSuggestions } from "../shared/FloorSuggestions/FloorSuggestions";
import { HaNContext } from "../shell/HaNContext";
import { AreaCell } from "./AreaCell";
import { AreasOnFloor } from "./components/AreasOnFloor";
import { SelectedFloorHeader } from "./components/SelectedFloorHeader";
import { useWorkspacesModel } from "./useWorkspacesModel";

export const WorkspacesList = () => {
  const { tab } = useRequiredContext(HaNContext);

  if (tab !== "workspaces") return null;

  return <WorkspacesListContent />;
};

const WorkspacesListContent = () => {
  const { suggestions } = useWorkspacesModel();

  return (
    <>
      <SelectedFloorHeader />

      <AreasOnFloor />

      <FloorSuggestions
        kind="area"
        suggestions={suggestions}
        renderCell={area => <AreaCell area={area} />}
      />
    </>
  );
};
